import { IRC_NONPROFIT_ID } from "../entity/constants";

/**
 * Note that "National Financial Services LLC" is technically the
 * subsidiary of Fidelity Investments Inc that the shares are going to.
 * On the phone Fidellity told me while "National Financial Services LLC"
 * is more technically correct and we should tell people that if they run
 * into any issues, if someone puts Fidelity that should work fine.
 */
const MUTUAL_FUND_BROKERAGE = {
  institution: "Fidelity Brokerage Services Inc",
  dtc: "0226",
  account: "Z28716200",
  title: "Every.org",
};

/**
 * Temporary separate stock account for IRC only
 */
const IRC_ONLY_BROKERAGE = {
  institution: "Fidelity Brokerage Services Inc",
  dtc: "0226",
  account: "Z33644104",
  title: "Every.org",
};

const IRC_ONLY_BROKERAGE_EFFECTIVE_DATE = new Date("2025-12-17");

// Remove once we've fully migrated away from Alpaca
// eslint-disable-next-line unused-imports/no-unused-vars
const STOCK_BROKERAGE = {
  institution: "AlpacaSecurities LLC",
  dtc: "3021",
  account: "456981656",
  title: "Every.org",
};

/**
 * Use Alpaca by default, for all Stocks and ETFs.
 * Alpaca does not support mutual funds.
 */
export function getBrokerageDtcInfo(
  nonprofitId: string,
  donationCreatedAt?: Date
) {
  // Alpaca isn't working so we're using Fidelity for all stock donations
  if (
    nonprofitId === IRC_NONPROFIT_ID &&
    donationCreatedAt &&
    donationCreatedAt >= IRC_ONLY_BROKERAGE_EFFECTIVE_DATE
  ) {
    return IRC_ONLY_BROKERAGE;
  }
  return MUTUAL_FUND_BROKERAGE;
}
